<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>Hermann Cohen and the Crisis of Liberalism</title>
<link href="../styles/9780253039767_template.css" rel="stylesheet" type="text/css"/>
<section epub:type="frontmatter" title="CONTENTS">
<p class="h2" id="con"><span class="right_1" epub:type="pagebreak" id="page_v" title="v"><b>CONTENTS</b></span></p>
<div class="top5"><p class="toc_1" id="rack"><a href="#/text/9780253039767_Acknowledgments"><i>Acknowledgments</i></a></p>
<div class="top1"><p class="toc_1" id="rabb"><a href="#/text/9780253039767_Abbreviations"><i>List of Abbreviations for Frequently Cited Sources</i></a></p>
<div class="top_1"><p class="toc_1" id="rint"><a href="#/text/9780253039767_Introduction">Introduction</a></p>
<p class="toc_2"><a href="#/text/9780253039767_Introduction"><i>Religion, Reason, and the Enchanted Public Sphere</i></a></p>
<div class="top"><p class="toc_3" id="rch1"><span href="#/text/9780253039767_Chapter_1" title="Link target outside of Sample">1.</span><span class="space"><span class="hide">    </span><span href="#/text/9780253039767_Chapter_1" title="Link target outside of Sample">Minor Protest(ant)s</span></span></p>
<p class="toc_2"><span href="#/text/9780253039767_Chapter_1" title="Link target outside of Sample"><i>Cohen and German-Jewish Liberalism</i></span></p>
<div class="top"><p class="toc_3" id="rch2"><span href="#/text/9780253039767_Chapter_2" title="Link target outside of Sample">2.</span><span class="space"><span class="hide">    </span><span href="#/text/9780253039767_Chapter_2" title="Link target outside of Sample">The Dialectic of Enchantment</span></span></p>
<p class="toc_2"><span href="#/text/9780253039767_Chapter_2" title="Link target outside of Sample"><i>Science, Religion, and Secular Reasoning</i></span></p>
<div class="top"><p class="toc_3" id="rch3"><span href="#/text/9780253039767_Chapter_3" title="Link target outside of Sample">3.</span><span class="space"><span class="hide">    </span><span href="#/text/9780253039767_Chapter_3" title="Link target outside of Sample">Rights, Religion, and Race</span></span></p>
<p class="toc_2"><span href="#/text/9780253039767_Chapter_3" title="Link target outside of Sample"><i>Cohen’s Ethical Socialism and the Specter of Anti-Semitism</i></span></p>
<div class="top"><p class="toc_3" id="rch4"><span href="#/text/9780253039767_Chapter_4" title="Link target outside of Sample">4.</span><span class="space"><span class="hide">    </span><span href="#/text/9780253039767_Chapter_4" title="Link target outside of Sample">Enchanted Reasoning</span></span></p>
<p class="toc_2"><span href="#/text/9780253039767_Chapter_4" title="Link target outside of Sample"><i>Self-Reflexive Religion and Minority</i></span></p>
<div class="top"><p class="toc_1" id="rconc"><span href="#/text/9780253039767_Conclusion" title="Link target outside of Sample">Conclusion</span></p>
<p class="toc_2"><span href="#/text/9780253039767_Conclusion" title="Link target outside of Sample"><i>Some Minor Reflections of Enchantment</i></span></p>
<div class="top_1"><p class="toc_1" id="rind"><span href="#/text/9780253039767_Index" title="Link target outside of Sample"><i>Index</i></span></p>
</div></div></div></div></div></div></div></div></div></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253039767_Contents.vue?3e64c6cd